<div
  class="navbar-shell flex flex-col"
  [class.chrome-dark]="themeService.isDark()"
  [class.chrome-light]="themeService.isLight()">
  <header class="navbar-bar relative flex items-center gap-3 px-3 sm:px-6">
    <div class="navbar-glow" aria-hidden="true"></div>

    <div class="relative z-10 flex items-center shrink-0">
      <button
        type="button"
        (click)="toggleSidebar.emit()"
        class="navbar-icon-btn lg:hidden"
        aria-label="Abrir menú">
        <mat-icon>menu</mat-icon>
      </button>
    </div>

    <div class="relative z-10 flex-1 max-w-2xl mx-auto min-w-0">
      @if (isAuthenticated()) {
      <p-inputgroup #globalSearchRoot class="navbar-global-search">
        <p-inputgroup-addon>
          <mat-icon class="navbar-search-icon">search</mat-icon>
        </p-inputgroup-addon>

        <div class="navbar-search-autocomplete-wrap">
          <p-autocomplete inputId="navbarGlobalSearch" class="w-full block" [ngModel]="search.term()"
            (ngModelChange)="search.term.set($event)" [suggestions]="search.suggestions()"
            [loading]="search.loading()"
            (completeMethod)="search.complete($event)" (onSelect)="search.select($event.value)"
            (onShow)="syncGlobalSearchPanelLayout()"
            optionLabel="displayLine" placeholder=" " [minLength]="3" [delay]="0"
            [forceSelection]="false" fluid styleClass="w-full" panelStyleClass="navbar-global-search-panel"
            [ariaLabel]="shortcuts.searchLauncherAriaLabel()">

            <ng-template pTemplate="item" let-item>
              <div class="search-hit">
                <span class="search-hit__icon" aria-hidden="true">
                  <i [class]="search.navIconClass(item.icon, item.entityType)" aria-hidden="true"></i>
                </span>
                <div class="search-hit__body">
                  <div class="search-hit__title">{{ item.title }}</div>
                  @if (item.description?.trim()) {
                  <div class="search-hit__desc">{{ item.description }}</div>
                  }
                </div>
              </div>
            </ng-template>
          </p-autocomplete>

          @if (showSearchShortcutHint()) {
          <app-search-shortcut-hint class="navbar-search-shortcut-hint" [overlay]="true" />
          }
        </div>

        <p-inputgroup-addon class="navbar-search-scope-addon">
          <button
            type="button"
            class="navbar-search-scope-label"
            aria-haspopup="menu"
            aria-label="Tipo de búsqueda"
            (click)="openSearchScopeMenu($event)">
            <i [class]="search.scopeIcon()" aria-hidden="true"></i>
            <span>{{ search.scopeLabel() }}</span>
          </button>
          <p-contextmenu
            #searchScopeMenu
            [model]="search.scopeMenuItems()"
            appendTo="body"
            styleClass="navbar-search-scope-menu"
            ariaLabel="Tipo de búsqueda" />
        </p-inputgroup-addon>

        <p-inputgroup-addon>
          <button type="button" class="navbar-notify-btn" aria-label="Notificaciones">
            <mat-icon>notifications</mat-icon>
          </button>
        </p-inputgroup-addon>
      </p-inputgroup>
      }
    </div>

    <div class="relative z-10 flex items-center gap-2 shrink-0">
      @if (isAuthenticated()) {
      <div class="relative" #userMenuRoot>
        <button type="button" class="user-chip" aria-label="Abrir menú de usuario" (click)="toggleUserMenu($event)">
          <div class="user-chip__meta hidden md:block">
            <p class="user-chip__name">{{ userName() }}</p>
            @if (userEmail()) {
            <p class="user-chip__email">{{ userEmail() }}</p>
            }
          </div>
          <span class="user-chip__avatar-wrap">
            <img class="user-chip__avatar" [src]="userPicture()" [attr.alt]="userName()">
            <span class="user-chip__status"></span>
          </span>
          <mat-icon class="user-chip__caret hidden sm:block">expand_more</mat-icon>
        </button>

        @if (isUserMenuOpen()) {
        <div class="user-menu animate-fade-in">
          <div class="user-menu__header">
            <img class="user-menu__avatar" [src]="userPicture()" [attr.alt]="userName()">
            <div class="min-w-0">
              <p class="user-menu__name">{{ userName() }}</p>
              @if (userEmail()) {
              <p class="user-menu__email">{{ userEmail() }}</p>
              }
            </div>
          </div>
          <button type="button" class="user-menu__item" (click)="goToProfile()">
            <mat-icon>person</mat-icon>
            <span>Perfil</span>
          </button>
          <button type="button" class="user-menu__item" (click)="themeService.toggleTheme(); closeUserMenu()">
            <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
            <span>{{ themeService.isDark() ? 'Tema claro' : 'Tema oscuro' }}</span>
          </button>
          <div class="user-menu__divider"></div>
          <button type="button" class="user-menu__item user-menu__item--danger" (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>Cerrar sesión</span>
          </button>
        </div>
        }
      </div>
      }
    </div>
  </header>

  @if (isSandbox()) {
  <div class="sandbox-banner">
    Estás trabajando en entorno <strong>Sandbox</strong>
  </div>
  }
</div>
